import { render, staticRenderFns } from "./Geraetegruppen.vue?vue&type=template&id=452ff7a0&scoped=true"
import script from "./Geraetegruppen.vue?vue&type=script&lang=js"
export * from "./Geraetegruppen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452ff7a0",
  null
  
)

export default component.exports